import { render, staticRenderFns } from "./Feature1.vue?vue&type=template&id=4ab11e42&"
import script from "./Feature1.vue?vue&type=script&lang=js&"
export * from "./Feature1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports